const routes = [
    {
        path: '/area_cliente_adm/integracoes/index',
        component: () => import('../views/IntegracaoLoja')
    }
]
export default routes
  